import { Component, OnInit} from '@angular/core';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { LoadingController } from 'ionic-angular';


@Component({
	selector: 'page-productview',
	templateUrl: 'productview.html',
	providers:[MydataService,MyUrlService,JsonData]
	
})
export class ProductviewPage {
	
	jsonDt : Array<JsonData>;
	productviewDt : Array<JsonData>;
    kilopartyOrderviewDt:Array<JsonData>;
	viewType:string;
	constructor(private http:Http,public loading: LoadingController,private mydataService: MydataService,private myurlService: MyUrlService) {
	}
	
	
	ngOnInit(){

		
		var cartids=window.localStorage.getItem('cartid');
		this.viewType	=window.localStorage.getItem('viewType');
		//alert(this.viewType);
		//alert(cartids);
		var kiloSabjiJSONdata = JSON.stringify({"cartid":cartids});
		//console.log("Product Url--->"+this.myurlService.MYCARTPRODUCTVIEW+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		if(window.localStorage.getItem('cartid')!=null){
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.MYCARTPRODUCTVIEW ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.productview(loader));
			
		});
		}else{
				this.kilopartyorderview();
		}
		
	}
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	productview=function(loader){
		window.localStorage.removeItem("cartid");
		this.productviewDt = this.jsonDt.addtocartdetail;
		//console.log("productview data jsondata ==>"+JSON.stringify(this.jsonDt));
		loader.dismiss();
		
	}
	
	kilopartyorderview=function()
	{
		var bookingid=window.localStorage.getItem('booking');
		//alert('dfgdgdffg=====>'+bookingid);
		var kiloSabjiJSONdata = JSON.stringify({"bookingid":bookingid});
		//console.log("OrderProductview Url--->"+this.myurlService.KILOPARTYORDERVIEW+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		
		let loader = this.loading.create({content: '',});
		
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.KILOPARTYORDERVIEW ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunctions(loader,error),() =>this.kilopartyordersview(loader));
			
		});
	}
	errorFunctions= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	kilopartyordersview=function(loader){
		window.localStorage.removeItem('booking');
		this.productviewDt = this.jsonDt.kilopartyorder;
		//console.log("kilopartyOrderview data jsondata ==>"+JSON.stringify(this.jsonDt.kilopartyorder));
		loader.dismiss();
		
	}
	
}



// WEBPACK FOOTER //
// ./src/pages/productview/productview.ts